/* globals Class */
window.lp.ModuleBase = Class.create({
  initialize: function(config, options) {
    Object.extend(this, config);
    this.options = options || {};
    this.activeElement = null;
    this.propertiesPanel = null;
    this.builderDialog = null;
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/module_base.js
// module id = 416
// module chunks = 0 1